import { render, staticRenderFns } from "./mallPage.vue?vue&type=template&id=2cb9af98&scoped=true"
import script from "./mallPage.vue?vue&type=script&lang=js"
export * from "./mallPage.vue?vue&type=script&lang=js"
import style0 from "./mallPage.vue?vue&type=style&index=0&id=2cb9af98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb9af98",
  null
  
)

export default component.exports